import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { useNavigate } from "react-router-dom";

import { participantIdAtom, romIdAtom, romPhaseAtom } from "@/atoms/rom.atoms";
import { serverHostAtom, serverPortAtom } from "@/atoms/settings.atoms";

/**
 * Listens for the `rom:closed` event (emitted by useRomHeartbeat when the
 * backend returns 410/404). A closed rom is NOT a session failure — the user
 * stays logged in. We clear the rom + persisted server host/port and redirect
 * to /connection-mode so the user can start a fresh pairing.
 */
export function useRomCloseListener() {
  const navigate = useNavigate();
  const setRomId = useSetAtom(romIdAtom);
  const setParticipantId = useSetAtom(participantIdAtom);
  const setPhase = useSetAtom(romPhaseAtom);
  const setServerHost = useSetAtom(serverHostAtom);
  const setServerPort = useSetAtom(serverPortAtom);

  useEffect(() => {
    const handler = () => {
      console.log(
        "[useRomCloseListener] rom closed — clearing local pairing state and redirecting to /connection-mode",
      );

      localStorage.removeItem("@Guest/serverHost");
      localStorage.removeItem("@Guest/serverPort");

      setRomId(null);
      setParticipantId(null);
      setPhase("pairing");
      setServerHost("");
      setServerPort("");

      navigate("/connection-mode", { replace: true });
    };

    window.addEventListener("rom:closed", handler);
    return () => window.removeEventListener("rom:closed", handler);
  }, [
    navigate,
    setRomId,
    setParticipantId,
    setPhase,
    setServerHost,
    setServerPort,
  ]);
}
